export default __webpack_public_path__ + "static/media/Techno Sportswear (P) Limited.d175829e.jpg";